/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var ConSerEntityIndividualsSectionView = require('../views/ConSerEntityIndividualsSectionView');
var GetIndividualsByEntity = require('../services/GetIndividualsByEntity');

module.exports = {
  channel: 'cs',

  event: 'build:individuals-section-view',

  builder: function(entityId) {
    return new PlaceholderView({
      viewPromise: buildIndividualsSectionView(entityId)
    });
  }
};

function buildIndividualsSectionView(entityId) {
  var deferred = $.Deferred();
  GetIndividualsByEntity(entityId)
    .done(function(individuals) {
      deferred.resolve(
        new ConSerEntityIndividualsSectionView({
          collection: new PageableCollection(individuals, { pageSize: 25 }),
          model: new Backbone.Model({ entityId: entityId })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
